// src/stone/icons/FaceHappy.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var FaceHappy = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12" }),
      /* @__PURE__ */ jsx("path", { d: "M8.797 13.396A1 1 0 0 0 7.2 14.6L8 14l-.8.6.001.001.001.002.003.004.007.009.021.027.07.086q.089.107.248.275c.213.222.522.513.923.805.798.58 2 1.191 3.526 1.191s2.728-.61 3.526-1.191a7 7 0 0 0 1.17-1.08q.045-.053.07-.086l.022-.027.007-.01.003-.003.001-.002S16.8 14.6 16 14l.8.6a1 1 0 0 0-1.597-1.204l-.005.006-.033.041q-.05.061-.16.178a5 5 0 0 1-.656.57c-.577.42-1.374.809-2.349.809s-1.772-.39-2.35-.809a5 5 0 0 1-.815-.748l-.034-.041zM9 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }),
      /* @__PURE__ */ jsx("path", { d: "M8.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M7 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }),
      /* @__PURE__ */ jsx("path", { d: "M15.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M14 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" })
    ]
  }
);
var FaceHappy_default = FaceHappy;

export {
  FaceHappy,
  FaceHappy_default
};
